module.exports = __webpack_public_path__ + "static/media/techCharacteristics1.69066a1e.png";